import { AxiosError } from 'axios';
import { PartnerService } from 'src/api';
import * as actions from '../actionTypes';

export const addPartner = data => async dispatch => {
  try {
    const response = await PartnerService.addPartner(data);
    dispatch({
      type: actions.ADD_PARTNER,
      payload: {
        message: {
          action: actions.ADD_PARTNER,
          success: response.data.successMessage,
        },
        partner: response.data.partnerContent,
      },
    });
  } catch (error) {
    dispatchError(actions.ADD_PARTNER, error, dispatch);
  }
};

export const getAllPartners = () => async dispatch => {
  try {
    const response = await PartnerService.getAllPartners();
    dispatch({
      type: actions.GET_ALL_PARTNERS,
      payload: {
        partners: response.data.allPartners,
      },
    });
  } catch (error) {
    dispatchError(actions.GET_ALL_PARTNERS, error, dispatch);
  }
};

export const getSinglePartner = slug => async dispatch => {
  try {
    const response = await PartnerService.getSinglePartner(slug);
    dispatch({
      type: actions.GET_SINGLE_PARTNER,
      payload: {
        partner: response.data.fetchedPartner,
      },
    });
  } catch (error) {
    dispatchError(actions.GET_SINGLE_PARTNER, error, dispatch);
  }
};

export const updatePartner = (id, data) => async dispatch => {
  try {
    const response = await PartnerService.updatePartner(id, data);
    dispatch({
      type: actions.UPDATE_PARTNER,
      payload: {
        message: {
          action: actions.UPDATE_PARTNER,
          success: response.data.successMessage,
        },
        partner: response.data.partnerContent,
      },
    });
  } catch (error) {
    dispatchError(actions.UPDATE_PARTNER, error, dispatch);
  }
};

export const deletePartner = id => async dispatch => {
  try {
    const response = await PartnerService.deletePartner(id);
    dispatch({
      type: actions.DELETE_PARTNER,
      payload: {
        message: {
          action: actions.DELETE_PARTNER,
          success: response.data.successMessage,
        },
        id,
      },
    });
  } catch (error) {
    dispatchError(actions.DELETE_PARTNER, error, dispatch);
  }
};

function dispatchError(actionType, error, dispatch) {
  if (error instanceof AxiosError) {
    dispatch({
      type: actions.PARTNER_ERROR,
      payload: {
        error: {
          action: actionType,
          message:
            error.response.data?.message ||
            error.response.data?.validationError ||
            error.message ||
            'Unknown error has occured',
          at: new Date(),
        },
      },
    });
  } else {
    dispatch({
      type: actions.PARTNER_ERROR,
      payload: {
        error: {
          action: actionType,
          message: 'Unknown error has occured',
          at: new Date(),
        },
      },
    });
  }
}
